import urlPrefix from "./apiPrefix";

export const getTaxAuthorityDepartmentList = () => `${urlPrefix.value}/tax-web-control/api/tax-authority-department/list`;
